import { CompanyIdentifierSystem } from "@/api-schema-enums";
import type { CompanyByUuidResponse } from "@/common/api/company/use-company-by-uuid.query";
import { formatDateToLocale } from "@/common/helpers/format-date";
import { SystemIdRow } from "@/components/detail-page/_components/system-id-row";
import { DetailTabCard } from "@/components/detail-page/_components/tab/detail-tab-card";
import { DetailTabGrid } from "@/components/detail-page/_components/tab/detail-tab-grid";
import { getCompanyIdentifier } from "@/modules/masterdata/company/company-identifiers";
import { FingerprintIcon, HashIcon } from "lucide-react";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

const COMPANY_IDENTIFIER_LABELS = [
  { system: CompanyIdentifierSystem.V1, labelKey: "masterdata:V1ID" },
  { system: CompanyIdentifierSystem.Sap, labelKey: "masterdata:CompanySapPrefix" },
] as const;

export function SystemIdsTab({ company }: { company: CompanyByUuidResponse }): ReactElement {
  const { t } = useTranslation(["masterdata", "common"]);

  return (
    <DetailTabGrid>
      <DetailTabCard icon={FingerprintIcon} title={t("common:External")}>
        <div className="flex flex-col gap-1">
          {COMPANY_IDENTIFIER_LABELS.map(({ system, labelKey }) => (
            <SystemIdRow key={system} label={t(labelKey)} value={getCompanyIdentifier(company, system)} mono copyable />
          ))}
        </div>
      </DetailTabCard>

      <DetailTabCard icon={HashIcon} title={t("common:Internal")}>
        <div className="flex flex-col gap-1">
          <SystemIdRow label={t("common:UUID")} value={company.uuid} mono copyable />
          <SystemIdRow label={t("common:TechnicalId")} value={company.technicalId} mono copyable />
          <SystemIdRow label={t("common:CreatedAt")} value={formatDateToLocale(company.createdAt)} />
          <SystemIdRow label={t("common:UpdatedAt")} value={formatDateToLocale(company.updatedAt)} />
          {company.deletedAt && (
            <SystemIdRow label={t("common:Deleted")} value={formatDateToLocale(company.deletedAt)} />
          )}
        </div>
      </DetailTabCard>
    </DetailTabGrid>
  );
}
